import { SBack, SFormUploadImage, SMessage } from 'shj-components'
import styles from '../../index.module.less'
import { Button, Image, Input, message, Spin, Upload, Space, Alert } from 'antd'
import { useEffect, useState } from 'react'
import { CloseCircleOutlined, CloseOutlined, InboxOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import {
  selectCustomDrawing,
  saveOrUpdateCustomDrawing,
  findSuppliersByOrderId,
  quoteGoodsDetail,
  selectCustomDrawingDetail,
  deleteCustomDrawingProcessInstance,
} from '@/services/order'
import { getToken } from 'shj-utils'
import { getXTransferInsideTenantId } from '@/utils/common'
import { baseURL } from '@/api'
import { useUpdateEffect } from 'ahooks'
import { cloneDeep, every, isArray } from 'lodash-es'
import { downloadImage } from '@wecom/jssdk'
import { fileDownload, fileLink } from '@/utils/download'

import SupplierAudit from './components/supplierAudit'
import SupplierAudits from './components/supplierAudits'

const { Dragger } = Upload

export default function DrawingManagement(props) {
  const { id, orderId } = useParams() // 报价商品id
  const [active, setActive] = useState<any>(0)
  const [hoverActive, setHoverActive] = useState<any>(0)
  const [drawerList, setDrawerList] = useState<any>([])
  const [spinning, setSpinning] = useState<boolean>(false)
  const [vendorVisible, setVendorVisible] = useState(false)
  const [open, setOpen] = useState(false)
  const [vendorList, setVendorList] = useState([])
  const [status, setStatus] = useState(false)
  const [customDrawingAuditFlag, setCustomDrawingAuditFlag] = useState(false)
  const [data, setData] = useState<any>({})
  useEffect(() => {
    // 查询图纸
    getData()
    init()
  }, [])
  const uploadFn = () => {
    getData()
    init()
  }
  const statusFn = list => {
    quoteGoodsDetail(id).then((res: any) => {
      console.log(res)
      setCustomDrawingAuditFlag(res.customDrawingAuditFlag)
      selectCustomDrawingDetail({ orderId, bizProcInstStatus: 'RUNNING' }).then((resp: any) => {
         console.log(resp)
        let dataList = cloneDeep(resp)
        list.forEach(item => {
          dataList?.drawingList?.forEach((eve, index) => {
            if (eve.vendorId === item.ucenterUserId) {
              eve.vendorName = item.vendorName
            }
             eve.drawingList.forEach(it => {
               it.thumbUrl = it.url
              it.status = 'done'
            })
          })
        })
         console.log(dataList)
        setData(dataList || {})
      })
    })
  }
  const init = () => {
    findSuppliersByOrderId({ orderId }).then(res => {
      console.log(res)
      setVendorList(res)
      statusFn(res)
    })
  }
  const getData = async () => {
    selectCustomDrawing({
      quoteGoodsId: id,
    }).then(res => {
      if (isArray(res)) {
        res = res.map(item => {
          return {
            ...item,
            type: 'text',
            status: 'done',
            thumbUrl: item.url,
          }
        })
        console.log(res)
        setDrawerList([...res])
      }
    })
  }
  // 实时更新数据
  const upDateData = data => {
    saveOrUpdateCustomDrawing({
      params: {
        quoteGoodsId: id,
      },
      data,
    }).then(res => {
      setSpinning(false)
      console.log(res)
      message.success(`操作成功`)
    })
  }

  const downloadImage = async () => {
    const requests = drawerList.map(item => {
      return fetch(`${item.url}?response-content-type=application/octet-stream`)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = item.name
          link.click()
          window.URL.revokeObjectURL(url)
        })
    })
    await Promise.all(requests)
  }

  const vendorFn = () => {
    setOpen(true)
  }

  const resetDrawerList = () => {
    SMessage.confirm({
      title: `确认撤回图纸？`,
      content: '发起后，将撤回该订单下所有定制图纸',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        deleteCustomDrawingProcessInstance({
          orderId,
          processInstanceId: data.processInstanceId,
        }).then((res: any) => {
          message.success(`操作成功`)
          getData()
          init()
        })
      },
    })
  }

  const propsUpload = {
    name: 'file',
    multiple: true,
    accept: '.dwg',
    action: baseURL + `file-web/file/upload`,
    // disabled: true,
    fileList: drawerList,
    onChange(info) {
      console.log(info)
      setDrawerList(info.fileList)
      const { status } = info.file
      const flag = every(info.fileList, ['status', 'done'])
      if (flag) {
        let dataList: any = []
        console.log(info)
        info.fileList.map(item => {
          dataList.push({
            name: item.name,
            type: 'text',
            url: item.url || item?.response?.data?.fileUrl,
            status: 'done',
            filePath: item.filePath || item?.response?.data?.filePath,
          })
        })
        console.log(dataList)

        setActive(dataList.length - 1)
        setDrawerList(dataList)
        upDateData(dataList)
        // message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        // message.error(`${info.file.name} file upload failed.`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  return (
    <SBack
      title={'图纸管理'}
      level={2}
      extra={[
        <div className={styles.btns} style={{ display: 'flex', alignItems: 'center' }}>
          {customDrawingAuditFlag && (
            <Alert
              message="当前图纸供应商已确认完成，若需修改，请先撤回图纸"
              type="info"
              showIcon
              style={{ marginRight: 30, backgroundColor: '#fff' }}
              banner
            />
          )}
          {!customDrawingAuditFlag && data?.processInstanceId && (
            <Alert
              message="当前图纸正在审核当中，若需修改，请先撤回图纸"
              type="info"
              showIcon
              style={{ marginRight: 30, backgroundColor: '#fff' }}
              banner
            />
          )}
          {!data?.processInstanceId ? (
            <>
              <span className={styles.garyDesc}>支持图片格式：JPEG/PNG/BMP，大小不超过10M </span>
              <Space>
                <Button disabled={!drawerList.length} onClick={downloadImage}>
                  下载图纸
                </Button>

                <Button
                  type="primary"
                  loading={spinning}
                  disabled={drawerList.length > 14}
                  onClick={vendorFn}
                >
                  供应商审核
                </Button>
              </Space>
            </>
          ) : (
            <>
              <span className={styles.garyDesc}>支持图片格式：JPEG/PNG/BMP，大小不超过10M </span>
              <Space>
                <Button disabled={!drawerList.length} onClick={downloadImage}>
                  下载图纸
                </Button>
                <Button type="primary" loading={spinning} onClick={resetDrawerList}>
                  撤回图纸
                </Button>
              </Space>
            </>
          )}
        </div>,
      ]}
    >
      {data?.processInstanceId ? (
        <div className={styles.dataList}>
          {data.drawingList.map((item, index) => {
            return (
              <div key={index} style={{ marginBottom: '20px' }}>
                <div className={styles.tit}>供应商名称：{item.vendorName}</div>
                <div>是否异形或玻台：{item.isUnCommon ? '是' : '否'}</div>
                <div>图纸列表：</div>
                <Upload
                  headers={{
                    Authorization: getToken?.(),
                    'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId(),
                  }}
                  action={baseURL + `file-web/file/upload`}
                  fileList={item.drawingList}
                  showUploadList={{
                    showRemoveIcon: false
                  }}
                ></Upload>
              </div>
            )
          })}
        </div>
      ) : (
        <div className={styles.customizeBox}>
          {/* <Spin spinning={spinning} style={{ width: '100%', height: '100%' }}> */}

          {/* 图片展示区 */}
          <div className={styles.customizedDrawingsBox}>
            {/* <Image.PreviewGroup>
            {drawerList[active]?.url && <Image width={'100%'} src={drawerList[active].url} />}
          </Image.PreviewGroup> */}
            <Dragger {...propsUpload}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p className="ant-upload-hint">请上传dwg文件，大小在60M以内，文件个数最多20个</p>
            </Dragger>
          </div>
          {/* </Spin> */}
        </div>
      )}

      <SupplierAudits
        title="发起供应商审核"
        open={open}
        setOpen={setOpen}
        uploadFn={uploadFn}
        orderId={orderId}
        vendorList={vendorList}
        drawerList={drawerList}
      />
    </SBack>
  )
}
